import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('koreksi-absen/index', {params});
    },
    show(id) {
        return Service().get('koreksi-absen/show/'+id);
    },
    create(params) {
        return Service().post('koreksi-absen/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('koreksi-absen/update/'+id, params);
    },
    delete(id) {
        return Service().post('koreksi-absen/delete/'+id);
    },
}
